<template>
  <el-dialog
    :title="查看"
    :close-on-click-modal="false"
    width="80%"
    :visible.sync="visible">
    <el-form label-width="120px" :model="dataForm" ref="dataForm" size="mini" style="margin-top:5px">
        <el-row :gutter="40">
            <el-col :span="11">
                <el-form-item label="索赔通知单号：" prop="claCode">
                    <el-input :disabled="true" width="50" v-model="dataForm.claCode"/>
                </el-form-item>
            </el-col>
            <el-col :span="11">
                <el-form-item label="索赔月份：" prop="ym">
                    <el-input :disabled="true" v-model="dataForm.ym"/>
                </el-form-item>
            </el-col>
        </el-row>
        <el-row :gutter="40">
            <el-col :span="11">
                <el-form-item label="供应商代码：" prop="venderCode">
                    <el-input :disabled="true" v-model="dataForm.venderCode"/>
                </el-form-item>
            </el-col>
            <el-col :span="11">
                    <el-form-item label="供应商名称：" prop="venderName">
                        <el-input :disabled="true" v-model="dataForm.venderName"/>
                    </el-form-item>
            </el-col>
        </el-row>
        <el-row :gutter="40">
            <el-col :span="11">
                <el-form-item label="索赔单总金额：" prop="totalSum">
                    <el-input :disabled="true" v-model="dataForm.totalSum"/>
                </el-form-item>
            </el-col>
            <el-col :span="11">
                <el-form-item label="索赔单状态：" prop="statusStr">
                    <el-input :disabled="true" v-model="dataForm.statusStr"/>
                </el-form-item>
            </el-col>
        </el-row>
        <el-row :gutter="40">
            <el-col :span="11">
                <el-form-item label="导入时间：" prop="createTimeStr">
                    <el-input :disabled="true" v-model="dataForm.createTimeStr"/>
                </el-form-item>
            </el-col>
        </el-row>
        <el-row :gutter="40">
            <el-col :span="11">
                <el-form-item label="最后更新时间：" prop="updateTimeStr">
                    <el-input :disabled="true" v-model="dataForm.updateTimeStr"/>
                </el-form-item>
            </el-col>
            <el-col :span="11">
                <el-form-item label="最后更新用户：" prop="updatedName">
                    <el-input :disabled="true" v-model="dataForm.updatedName"/>
                </el-form-item>
            </el-col>
        </el-row>
    </el-form>
    <div v-loading="dataListLoading">
        <el-table :data="dataList" size="mini" :row-class-name="rowClassName"
                  :height="style.gridStyle.height" @selection-change="selectionChangeHandle"
                  :header-cell-style="{background:'#f5f5f5'}" border>
            <el-table-column header-align="center" label="序号" align="center" width="50">
                <template slot-scope="scope">
                    {{ scope.row.rowid }}
                </template>
            </el-table-column>
            <el-table-column prop="werk" header-align="center" align="center" label="工厂" min-width="80">
                <template slot-scope="scope">
                    {{ scope.row.werk }}
                </template>
            </el-table-column>
            <el-table-column prop="cx" header-align="center" align="left" label="车型" min-width="90">
                <template slot-scope="scope">
                     {{ scope.row.cx }}
                </template>
            </el-table-column>
            <el-table-column prop="partCode" header-align="center" align="center" label="零件编号" min-width="90">
                <template slot-scope="scope">
                    {{ scope.row.partCode }}
                </template>
            </el-table-column>
            <el-table-column prop="partName" header-align="center" align="center" label="零件名称" min-width="120">
                <template slot-scope="scope">
                    {{ scope.row.partName }}
                </template>
            </el-table-column>
            <el-table-column prop="gdCount" header-align="center" align="center" label="工单数" min-width="60" >
                <template slot-scope="scope">
                    {{ scope.row.gdCount }}
                </template>
            </el-table-column>
            <el-table-column prop="gzxx" header-align="center" align="center" label="故障现象" min-width="100" >
                <template slot-scope="scope">
                    {{ scope.row.gzxx }}
                </template>
            </el-table-column>
            <el-table-column prop="clfa" header-align="center" align="center" label="处理方案" min-width="150" >
                <template slot-scope="scope">
                    {{ scope.row.clfa }}
                </template>
            </el-table-column>
            <el-table-column prop="gsf" header-align="center" align="center" label="工时费" min-width="60" >
                <template slot-scope="scope">
                    {{ scope.row.gsf }}
                </template>
            </el-table-column>
            <el-table-column prop="clf" header-align="center" align="center" label="材料费（管理费）" min-width="70" >
                <template slot-scope="scope">
                    {{ scope.row.clf }}
                </template>
            </el-table-column>
            <el-table-column prop="qtfy" header-align="center" align="center" label="其他费用" min-width="70" >
                <template slot-scope="scope">
                    {{ scope.row.qtfy }}
                </template>
            </el-table-column>
            <el-table-column prop="jjyf" header-align="center" align="center" label="旧件运费" min-width="70" >
                <template slot-scope="scope">
                    {{ scope.row.jjyf }}
                </template>
            </el-table-column>
            <el-table-column prop="lineSum" header-align="center" align="center" label="行项金额小计" min-width="60" >
                <template slot-scope="scope">
                    {{ scope.row.lineSum }}
                </template>
            </el-table-column>
        </el-table>
        <el-pagination @size-change="sizeChangeHandle" @current-change="currentChangeHandle" :current-page="pageIndex"
                       :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" :total="totalPage"
                       layout="total, sizes, prev, pager, next, jumper">
        </el-pagination>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">确定</el-button>
      <!--<el-button type="primary" @click="dataFormSubmit()">确定</el-button>-->
    </span>
  </el-dialog>
</template>

<script>
import {
    getSupplierClaList
} from '@/controller/supplier'
import {
    getLabelByValue,
    CLA_STATUS_VALUE,
} from "@/utils/const";
  export default {
    data () {
      return {
        visible: false,
        dataForm: {
            claId: '',
            claCode: '',
            ym: '',
            venderCode: '',
            venderName: '',
            totalSum: '',
            status: '',
            createTimeStr: '',
            updateTimeStr: '',
            updatedName: '',
            statusStr: '',
        },
        dataList: [],
        pageIndex: 1,
        pageSize: 10,
        totalPage: 0,
        dataListLoading: false,
        dataListSelections: [],
        CLA_STATUS_VALUE: CLA_STATUS_VALUE,
        getLabelByValue: getLabelByValue,
        style: {
            leftStyle: {
                height: (parseInt(document.documentElement['clientHeight']) - 325) + "px",
                overflow: "auto"
            },
            rightStyle: {
                height: (parseInt(document.documentElement['clientHeight']) - 205) + "px"
            },
            gridStyle: {
                height: (parseInt(document.documentElement['clientHeight']) - 215) + "px"
            }
        },
      }
    },
    methods: {
        init (row) {
            debugger
            this.dataForm.claId = row.id
            this.dataForm.claCode = row.claCode
            this.dataForm.ym = row.ym
            this.dataForm.venderCode = row.venderCode
            this.dataForm.venderName = row.venderName
            this.dataForm.totalSum = row.totalSum
            this.dataForm.status = row.status
            this.dataForm.createTimeStr = row.createTimeStr
            this.dataForm.updateTimeStr = row.updateTimeStr
            this.dataForm.updatedName = row.updatedName
            this.dataForm.statusStr = row.statusStr
            this.visible = true
            this.getDataList()
       },
       // 获取数据列表
       getDataList() {
          debugger
          this.dataListLoading = true
          getSupplierClaList({
              'pageNo': this.pageIndex,
              'pageSize': this.pageSize,
              'claId': this.dataForm.claId
          }).then(data => {
              if (data && data.code === '00') {
                  this.dataList = data.body.records
                  this.totalPage = data.body.total
              } else {
                  this.dataList = []
                  this.totalPage = 0
              }
          }).catch((e) => {
              console.log(e)
          }).finally(() => {
              this.dataListLoading = false
          })
      },
      // 每页数
      sizeChangeHandle(val) {
          this.pageSize = val
          this.pageIndex = 1
          this.getDataList()
      },
      // 当前页
      currentChangeHandle(val) {
          this.pageIndex = val
          this.getDataList()
      },
      //多选
      selectionChangeHandle(val) {
          console.log(val)
          this.dataListSelections = val
      },
      rowClassName({
                       row,
                       rowIndex
                   }) {
          //把每一行的索引放进row.id
          row.rowid = rowIndex + 1 + (this.pageSize * (this.pageIndex - 1));
      },
      statusFormat: function (value) {
          if (!value) {
              return "";
          }
          return getLabelByValue(CLA_STATUS_VALUE, value);
      },
    }
  }
</script>
